module.exports = __webpack_public_path__ + "fonts/e2cf3dc.woff";